import scrollTop from "../ScrollTop/index.vue";
export default (Vue) => {
	Vue.component(scrollTop.name, scrollTop);
};
